module.exports = __webpack_public_path__ + "img/as.70d9a9f5.png";